<script lang="ts" setup>
defineProps<{
  text: string
}>()
</script>

<template>
  <p class="!m-0 text-xs leading-[1.33] text-main-dark opacity-50 md:text-sm md:leading-[1.43]">
    {{ text }}
  </p>
</template>
